import { DPAM_TAG_ID } from "@constants";

/**
 * Type for content that can have Contentful tags
 */
type TaggedContent = {
    metadata?: {
        tags?: Array<{
            contentful_id: string;
        }>;
    };
};

/**
 * Simple utility to check if content should be included based on DPAM tagging rules.
 * Returns true if content has the DPAM tag OR has no tags at all.
 */
export const isDpamContent = (content: TaggedContent): boolean => {
    const tags = content.metadata?.tags || [];
    const hasTargetTag = tags.some(tag => tag.contentful_id === DPAM_TAG_ID);
    const hasNoTags = tags.length === 0;
    return hasTargetTag || hasNoTags;
};
